import { render, staticRenderFns } from "./addSchool.vue?vue&type=template&id=09f1a4d2&scoped=true"
import script from "./addSchool.vue?vue&type=script&lang=js"
export * from "./addSchool.vue?vue&type=script&lang=js"
import style0 from "./addSchool.vue?vue&type=style&index=0&id=09f1a4d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f1a4d2",
  null
  
)

export default component.exports